import ChallengeTypeDate from './ChallengeTypeDate';

export default ChallengeTypeDate;
